export default "__VITE_ASSET__Ctk1JfEE__"